import React, { Dispatch, SetStateAction } from 'react';

import * as S from './styles';

import type { IDocumentsDegree } from '../../../../../../../types/newStudent/documents.interface';
import {
  isDraftDocumentsDegreeRow,
  sumHoursDegree,
} from '../../../../../../../util/newStudent/documentsDegree';
import DegreeInput from './components/DegreeInput';

interface Props {
  open: number | undefined;
  courseId: number | undefined;
  newData: IDocumentsDegree[] | [];
  setNewData: Dispatch<SetStateAction<IDocumentsDegree[] | []>>;
  setOldData: Dispatch<SetStateAction<IDocumentsDegree[] | []>>;
  oldData: IDocumentsDegree[] | [];
  documentDegreeType: number;
  registrationId: number;
  universityDegreeId: number;
  degreeMetaComplete?: boolean;
}
export default function DocumentDegree({
  oldData,
  open,
  courseId,
  setNewData,
  newData,
  documentDegreeType,
  registrationId,
  universityDegreeId,
  setOldData,
  degreeMetaComplete = false,
}: Props) {
  const allItems = [...newData, ...oldData].filter(
    (i) => i.situation != null && i.situation !== undefined,
  );
  const hours = sumHoursDegree(allItems);

  return (
    <S.Container>
      {open === courseId && (
        <S.ContainerFocus>
          {allItems.length > 0 && (
            <S.InfoHours>
              <strong>Horas Aguardando:</strong> {hours.horasAguardando}
              <br />
              <strong>Horas Aprovadas:</strong> {hours.horasAprovadas}
            </S.InfoHours>
          )}
          {newData
            .filter(
              (item) =>
                !degreeMetaComplete || !isDraftDocumentsDegreeRow(item),
            )
            .map((item: IDocumentsDegree, index: number) => (
              <DegreeInput
                key={index}
                index={index}
                item={item}
                registrationId={registrationId}
                universityDegreeId={universityDegreeId}
                setNewData={setNewData}
                newData={newData}
                documentDegreeType={documentDegreeType}
                degreeMetaComplete={degreeMetaComplete}
              />
            ))}
          {oldData.map((item: IDocumentsDegree, index: number) => (
            <DegreeInput
              key={index}
              index={index}
              item={item}
              registrationId={registrationId}
              universityDegreeId={universityDegreeId}
              isOld
              setOldData={setOldData}
              oldData={oldData}
              documentDegreeType={documentDegreeType}
              degreeMetaComplete={degreeMetaComplete}
            />
          ))}
        </S.ContainerFocus>
      )}
    </S.Container>
  );
}
